import Vue from "vue";
import Vuex, { StoreOptions } from "vuex";
import VuexPersist from "vuex-persist";
import { RootState } from "./types";
import { user } from "./user";

Vue.use(Vuex);

const vuexSessionStorage = new VuexPersist<RootState>({
  key: "state",
  storage: window.sessionStorage
});

const store: StoreOptions<RootState> = {
  state: {},
  modules: {
    user
  },
  plugins: [vuexSessionStorage.plugin]
};

export default new Vuex.Store<RootState>(store);
